import { render, staticRenderFns } from "./RoleProfileItem.vue?vue&type=template&id=fb2b700c"
import script from "./RoleProfileItem.vue?vue&type=script&lang=js"
export * from "./RoleProfileItem.vue?vue&type=script&lang=js"
import style0 from "./RoleProfileItem.vue?vue&type=style&index=0&id=fb2b700c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports